export default "__VITE_ASSET__8d073edc__"